import { render, staticRenderFns } from "./catStatics.vue?vue&type=template&id=ecf93612&scoped=true"
import script from "./catStatics.vue?vue&type=script&lang=js"
export * from "./catStatics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf93612",
  null
  
)

export default component.exports